import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../pages/home.js'
import Notfound from '../pages/notfound.js'
import CandidateRegistration from '../pages/candidateRegistration.js'
import UserLogin from '../pages/userLogin.js'
import EmployeeRegistration from '../pages/employeeRegistration.js'
import Dashboard from '../pages/dashboard.js'
import Applications from '../pages/applications.js'
import Candidates from '../pages/candidates.js'
import Teams from '../pages/teams.js'
import Chats from '../pages/chats.js'
import Analytics from '../pages/analytics.js'
import ApplicationForm from '../pages/applicationForm.js'
import Tracking from '../pages/tracking.js'
import TrackingDetails from '../pages/trackingDetails.js'
import ApplicationDetails from '../pages/applicationDetails.js'
import ManageApplication from '../pages/manageApplication.js'
import CandidateDetails from '../pages/candidateDetails.js'
import Employees from '../pages/employees.js'
import Joinees from '../pages/joinees.js'
import JoiningForm from '../pages/joiningForm.js'
import Account from '../pages/account.js'
import Trainees from '../pages/trainees.js'
import ProtectedRoute from '../config/protectedRoute.js'
import Unauthorized from '../pages/unauthorized.js'
import App from '../App.js'
import Settings from '../pages/settings.js'
import NewTrainees from '../pages/newTrainees.js'
import ComingSoon from '../pages/comingSoon.js'
import NewApplications from '../pages/newApplications.js'
import ResetPassword from '../pages/resetPassword.js'
import Enquiries from '../pages/enquiries.js'
import SelelctedApplications from '../pages/selectedApplications.js'
import RejectedApplications from '../pages/rejectedApplications.js'
import CreateTeam from '../pages/createTeam.js'
import OfferedApplications from '../pages/offeredApplications.js'
import InterviewQueue from '../pages/interviewQueue.js'
import InterviewQueueBoard from '../pages/interviewQueueBoard.js'
import TeamDetails from '../pages/teamDetails.js'
import ManageTeam from '../pages/manageTeam.js'
import EmployeeDocumentUpload from '../pages/employeeDocumentUpload.js'
import EmployeeThankYou from '../pages/employeeThankyou.js'
import EmployeeDetails from '../pages/employeeDetails.js'
import ManageEmployee from '../pages/manageEmployee.js'
import CreateEmployee from '../pages/createEmployee.js'
import HoldApplications from '../pages/holdApplications.js'
import OnboardingList from '../pages/onboardingList.js'
import RecruiterLeaderboard from '../pages/recruiterLeaderboard.js'
import SalesDashboard from '../pages/salesDashboard.js'
import Orders from '../pages/orders.js'
import PortalLander from '../pages/lander.js'
import PayrollDashboard from '../pages/payrollDashboard.js'
import MyDocuments from '../pages/myDocuments.js'
import MyPaySlips from '../pages/myPaySlips.js'
import HelpPage from '../pages/help.js'
import Notifications from '../pages/notifications.js'
import RecruiterDashboard from '../pages/recruiterDashboard.js'
import UploadAttendance from '../pages/uploadAttendance.js'
import Attendance from '../pages/attendance.js'
import AttendanceList from '../pages/attendanceList.js'
import TicketList from '../pages/ticketList.js'
import Shipments from '../pages/shiprocketShipments.js'
import ShipmentDetails from '../pages/shipmentDetails.js'
import PastJoining from '../pages/pastJoining.js'
import PayrollEmployees from '../pages/payrollEmployees.js'
import PayrollEmployeeManage from '../pages/payrollEmployeeManage.js'
import OzonetelDashboard from '../pages/ozonetelDashboard.js'
import PermissionsGuide from '../pages/permissionsGuide.js'
import ManageAttendance from '../pages/manageAttendance.js'
import CareersPage from '../pages/careers.js'
import ThankYouPage from '../pages/thankyou.js'
import EmployeeManagement from '../pages/employeeManagement.js'
import OnlineApplications from '../pages/onlineApplications.js'
import OnlineApplicationDetails from '../pages/onlineApplicationDetails.js'
import LogisticsSpecialist from '../pages/logisticsSpecialist.js'
import OADashboard from '../pages/OADashboard.js'
import Danger from '../pages/danger.js'
import LoginOtpVerificationPage from '../pages/otpVerificationPage.js'
import ApplicationFlow from '../pages/applicationFlow.js'
import BatchDetails from '../pages/batchDetails.js'
import BatchListing from '../pages/batches.js'
import CreateBatch from '../pages/createBatch.js'
import ManageBatch from '../pages/manageBatch.js'
import Report from '../pages/report.js'
import FilterApplications from '../pages/filterApplications.js'
import ApplicationsSheet from '../pages/applicationsSheet.js'
import SurveyReportPage from '../pages/surveyReportPage.js'
import Surveys from '../pages/surveys.js'
import Referrals from '../pages/referrals.js'
import ResumeList from '../pages/resumeList.js'
import Grievances from '../pages/grievances.js'
import ManageGrievance from '../pages/manageGrievance.js'
import UploadDocumentsByToken from '../pages/uploadDocumentsByToken.js'
import DocumentSummary from '../pages/documentSummary.js'
import DemoPage from '../pages/demoPage.js'
import WeekoffRoster from '../pages/weekoffRoster.js'
import IJPRequests from '../pages/ijpAllListing.js'
import CreateRecruiter from '../pages/createRecruiter.js'
import RecruiterList from '../pages/recruiters.js'
import ApplicationInvite from '../pages/applicationInvite.js'
import PaymentsList from '../pages/paymentsList.js'
import RecruiterApplications from '../pages/recruiterApplications.js'
import RecruitmentAnalytics from '../pages/analytics/recruitment.js'
import SalesDisplay from '../pages/salesDisplay.js'
import FloorsDisplay from '../pages/floors-display.js'
import LoginApprovalManagement from '../pages/loginApprovalManagement.js'
import ManagerDisplay from '../pages/manager-display.js'
import ManagerFloorDisplay from '../pages/managerFloorDisplay.js'
import AdvancedScreen from '../pages/advancedScreen.js'
import JoinEmployee from '../pages/joinEmployee.js'
import AgentDisplay from '../pages/agentDisplay.js'
import Agent from '../pages/agent.js'
import Leads from '../pages/leads.js'
import LeadDetails from '../pages/leadDetails.js'
import LiveBattleDisplay from '../pages/liveBattleDisplay.js'
import Conducts from '../pages/conducts.js'
import SalesFightArena from '../pages/salesFightArena.js'
import WideScreen from '../pages/wideScreen.js'
import TestScreen from '../pages/testScreen.js'
import WideScreenAnimated from '../pages/wideScreenAnimated.js'
import RecruiterCareer from '../pages/recruiterCareer.js'
import SalesReports from '../pages/salesReports.js'
import ManagerOrderWidescreen from '../pages/managerOrderWidescreen.js'
import Nexus from '../pages/nexus.js'
import CentralReport from '../pages/centralReport.js'


const RoutesPage = () => {
    return (
        <Routes>
            <Route path="/" element={<UserLogin />} />
            <Route path="/home" element={<Home />} />
            <Route path="*" element={<Notfound />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/danger" element={<Danger />} />
            <Route path="/verify-otp" element={<LoginOtpVerificationPage />} />
            <Route path="/help/application-flow" element={<ApplicationFlow />} />
            <Route path="/help/permissions-guide" element={<PermissionsGuide />} />


            <Route path="/login-approval-management" element={<ProtectedRoute resource="team" actions={["read", "write", "update"]}><LoginApprovalManagement /></ProtectedRoute>} />




            <Route path="/resumes" element={<ProtectedRoute resource="resume" actions={["read", "write", "update"]}><ResumeList /></ProtectedRoute>} />

            <Route path="/lander" element={<ProtectedRoute resource="dashboard" actions={["read", "write", "update"]}><PortalLander /></ProtectedRoute>} />

            {/* nolayout */}
            <Route path="/nolayout/applications/:applicationObjId/manage" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><ManageApplication /></ProtectedRoute>} />



            <Route path="/batches/:batchObjId" element={<ProtectedRoute resource="batch" actions={["read", "write", "update"]}><BatchDetails /></ProtectedRoute>} />
            <Route path="/batches" element={<ProtectedRoute resource="batch" actions={["read", "write", "update"]}><BatchListing /></ProtectedRoute>} />
            <Route path="/batches/create" element={<ProtectedRoute resource="batch" actions={["read", "write", "update"]}><CreateBatch /></ProtectedRoute>} />
            <Route path="/batches/:batchObjId/manage" element={<ProtectedRoute resource="batch" actions={["read", "write", "update"]}><ManageBatch /></ProtectedRoute>} />


            <Route path="/referrals" element={<ProtectedRoute resource="referral" actions={["read", "write", "update"]}><Referrals /></ProtectedRoute>} />


            <Route path="/grievances" element={<ProtectedRoute resource="grievance" actions={["read", "write", "update"]}><Grievances /></ProtectedRoute>} />
            <Route path="/grievances/:grievanceObjId/manage" element={<ProtectedRoute resource="grievance" actions={["read", "write", "update"]}><ManageGrievance /></ProtectedRoute>} />

            <Route path="/hrms/dashboard" element={<ProtectedRoute resource="dashboard" actions={["read", "write", "update"]}><Dashboard /></ProtectedRoute>} />
            <Route path="/report" element={<ProtectedRoute resource="dashboard" actions={["read", "write", "update"]}><Report /></ProtectedRoute>} />


            <Route path="/applications/advanced-search" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><FilterApplications /></ProtectedRoute>} />
            <Route path="/applications/sheet" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><ApplicationsSheet /></ProtectedRoute>} />

            <Route path="/applications/:applicationObjId/manage" element={<ProtectedRoute resource="application" actions={["write", "update"]}><ManageApplication /></ProtectedRoute>} />
            <Route path="/applications/:applicationObjId" element={<ProtectedRoute resource="application" actions={["read"]}><ApplicationDetails /></ProtectedRoute>} />
            <Route path="/applications/new-applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><NewApplications /></ProtectedRoute>} />
            <Route path="/new-applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><NewApplications /></ProtectedRoute>} />
            <Route path="/selected-applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><SelelctedApplications /></ProtectedRoute>} />
            <Route path="/rejected-applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><RejectedApplications /></ProtectedRoute>} />
            <Route path="/offered-applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><OfferedApplications /></ProtectedRoute>} />
            <Route path="/applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><Applications /></ProtectedRoute>} />
            <Route path="/hold-applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><HoldApplications /></ProtectedRoute>} />


            <Route path="/candidates" element={<ProtectedRoute resource="candidate" actions={["read", "write", "update"]}><Candidates /></ProtectedRoute>} />
            <Route path="/trainees" element={<ProtectedRoute resource="trainee" actions={["read", "write", "update"]}><Trainees /></ProtectedRoute>} />
            <Route path="/new-trainees" element={<ProtectedRoute resource="trainee" actions={["read", "write", "update"]}><NewTrainees /></ProtectedRoute>} />
            <Route path="/joinees" element={<ProtectedRoute resource="joinee" actions={["read", "write", "update"]}><Joinees /></ProtectedRoute>} />
            <Route path="/onboarding-list" element={<ProtectedRoute resource="joinee" actions={["read", "write", "update"]}><OnboardingList /></ProtectedRoute>} />
            <Route path="/employees" element={<ProtectedRoute resource="employee" actions={["read", "write", "update"]}><Employees /></ProtectedRoute>} />
            <Route path="/employees/create" element={<ProtectedRoute resource="employee" actions={["read", "write", "update"]}><CreateEmployee /></ProtectedRoute>} />
            <Route path="/employees/:employeeObjId" element={<ProtectedRoute resource="employee" actions={["read", "write", "update"]}><EmployeeDetails /></ProtectedRoute>} />
            <Route path="/employees/:employeeObjId/manage" element={<ProtectedRoute resource="employee" actions={["read", "write", "update"]}><ManageEmployee /></ProtectedRoute>} />
            <Route path="/teams/create" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><CreateTeam /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><Settings /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute resource="dashboard" actions={["read", "write", "update"]}><Account /></ProtectedRoute>} />
            <Route path="/past-joining" element={<ProtectedRoute resource="joinee" actions={["read", "write", "update"]}><PastJoining /></ProtectedRoute>} />

            {/* <Route path="/account" element={<Account />} />
            <Route path="/settings" element={<Settings />} /> */}




            <Route path="/recruiters/create-recruiter" element={<ProtectedRoute resource="recruiter" actions={["read", "write", "update"]}><CreateRecruiter /></ProtectedRoute>} />
            <Route path="/recruiters" element={<ProtectedRoute resource="recruiter" actions={["read", "write", "update"]}><RecruiterList /></ProtectedRoute>} />


            <Route path="/analytics" element={<ProtectedRoute resource="analytics" actions={["read", "write", "update"]}><Analytics /></ProtectedRoute>} />



            <Route path="/payments" element={<ProtectedRoute resource="payment" actions={["read", "write", "update"]}><PaymentsList /></ProtectedRoute>} />



            <Route path="/features/invite-application" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><ApplicationInvite /></ProtectedRoute>} />



            <Route path="/recruiter/leaderboard" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><RecruiterLeaderboard /></ProtectedRoute>} />
            {/* <Route path="/recruiter/dashboard" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><RecruiterDashboard /></ProtectedRoute>}/> */}
            <Route path="/recruiter/dashboard" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><RecruiterApplications /></ProtectedRoute>} />
            <Route path="/recruiter/applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><RecruiterApplications /></ProtectedRoute>} />

            <Route path="/employees/document-summary" element={<ProtectedRoute resource="employee" actions={["read", "write", "update"]}><DocumentSummary /></ProtectedRoute>} />

            <Route path="/online-applications" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><OADashboard /></ProtectedRoute>} />
            <Route path="/online-applications/:jobId" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><OnlineApplications /></ProtectedRoute>} />
            <Route path="/online-applications/:jobId/:applicationObjId" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><OnlineApplicationDetails /></ProtectedRoute>} />

            <Route path="/enquiries" element={<ProtectedRoute resource="application" actions={["read", "write", "update"]}><Enquiries /></ProtectedRoute>} />
            <Route path="/interview-queue" element={<ProtectedRoute resource="interview" actions={["read", "write", "update"]}><InterviewQueue /></ProtectedRoute>} />

            <Route path="/teams" element={<ProtectedRoute resource="team" actions={["read", "write", "update"]}><Teams /></ProtectedRoute>} />
            <Route path="/teams/:userObjId" element={<ProtectedRoute resource="team" actions={["read", "write", "update"]}><TeamDetails /></ProtectedRoute>} />
            <Route path="/teams/:userObjId/manage" element={<ProtectedRoute resource="team" actions={["read", "write", "update"]}><ManageTeam /></ProtectedRoute>} />

            <Route path="/candidate/registration" element={<CandidateRegistration />} />
            <Route path="/employees/registration" element={<EmployeeRegistration />} />
            <Route path="/employees/joining-form/:employeeToken" element={<JoiningForm />} />
            <Route path="/employees/joining-form/:employeeToken/upload-documents" element={<EmployeeDocumentUpload />} />
            <Route path="/employees/thankyou/:employeeToken/:employeeId" element={<EmployeeThankYou />} />
            <Route path="/employees/thankyou/:employeeToken" element={<EmployeeThankYou />} />
            {/* <Route path="/applications" element={<Applications />} /> */}
            {/* <Route path="/applications/:aplicationObjId" element={<ApplicationDetails />} /> */}
            {/* <Route path="/applications/:applicationObjId/manage" element={<ManageApplication />} /> */}
            {/* <Route path="/candidates" element={<Candidates />} /> */}

            <Route path="/candidates/:candidateObjId" element={<ProtectedRoute resource="candidate" actions={["read", "write", "update"]}><CandidateDetails /></ProtectedRoute>} />


            <Route path="/upload-documents/:employeeToken" element={<UploadDocumentsByToken />} />
            {/* <Route path="/teams" element={<Teams />} /> */}
            <Route path="/chats" element={<Chats />} />
            <Route path="/demo" element={<DemoPage />} />

            {/* <Route path="/joining-form" element={<JoiningForm />} /> */}



            <Route path="/application-form" element={<ApplicationForm />} />
            <Route path="/tracking" element={<Tracking />} />
            <Route path="/tracking-details" element={<TrackingDetails />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* <Route path="/interview-queue" element={<InterviewQueue />} /> */}
            <Route path="/interview-queue-board" element={<InterviewQueueBoard />} />

            <Route path="/careers/content-writing" element={<CareersPage />} />
            <Route path="/careers/recruiter" element={<RecruiterCareer />} />
            <Route path="/careers/logistics-specialist" element={<LogisticsSpecialist />} />
            <Route path="/careers/thank-you" element={<ThankYouPage />} />




            <Route path="/surveys/:surveyId/report" element={<ProtectedRoute resource="survey" actions={["read", "write", "update"]}><SurveyReportPage /></ProtectedRoute>} />
            <Route path="/surveys" element={<ProtectedRoute resource="survey" actions={["read", "write", "update"]}><Surveys /></ProtectedRoute>} />



            <Route path="/ijp-requests" element={<ProtectedRoute resource="ijp_request" actions={["read", "write", "update"]}><IJPRequests /></ProtectedRoute>} />

            <Route path="/sales/dashboard" element={<ProtectedRoute resource="sales" actions={["read", "write", "update"]}><SalesDashboard /></ProtectedRoute>} />
            <Route path="/sales/orders" element={<ProtectedRoute resource="sales" actions={["read", "write", "update"]}><Orders /></ProtectedRoute>} />
            <Route path="/sales/shipments" element={<ProtectedRoute resource="sales" actions={["read", "write", "update"]}><Shipments /></ProtectedRoute>} />
            <Route path="/sales/shipments/:awb" element={<ProtectedRoute resource="sales" actions={["read", "write", "update"]}><ShipmentDetails /></ProtectedRoute>} />
            <Route path="/sales/ozonetel" element={<ProtectedRoute resource="sales" actions={["read", "write", "update"]}><OzonetelDashboard /></ProtectedRoute>} />



            <Route path="/payroll/attendance/:employeeId" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><Attendance /></ProtectedRoute>} />
            <Route path="/payroll/attendance" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><AttendanceList /></ProtectedRoute>} />
            <Route path="/payroll/documents" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><MyDocuments /></ProtectedRoute>} />
            <Route path="/payroll/pay-slips" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><MyPaySlips /></ProtectedRoute>} />
            <Route path="/payroll/dashboard" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><PayrollDashboard /></ProtectedRoute>} />
            <Route path="/payroll/tickets" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><TicketList /></ProtectedRoute>} />
            <Route path="/payroll/notifications" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><Notifications /></ProtectedRoute>} />
            <Route path="/payroll/upload-attendance" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><UploadAttendance /></ProtectedRoute>} />
            <Route path="/payroll/employee-management" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><EmployeeManagement /></ProtectedRoute>} />
            <Route path="/payroll/employees" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><PayrollEmployees /></ProtectedRoute>} />
            <Route path="/payroll/employees/:employeeObjId" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><PayrollEmployeeManage /></ProtectedRoute>} />
            <Route path="/payroll/manage-attendance" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><ManageAttendance /></ProtectedRoute>} />
            <Route path="/payroll/weekoff-roster" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><WeekoffRoster /></ProtectedRoute>} />







            <Route path="/analytics/recruitment" element={<ProtectedRoute resource="analytic_recruitment" actions={["read", "write", "update"]}><RecruitmentAnalytics /></ProtectedRoute>} />





            <Route path="/sales-display" element={<SalesDisplay />} />
            <Route path="/screen/floors-display" element={<FloorsDisplay />} />
            <Route path="/screen/manager-display" element={<ManagerDisplay />} />
            <Route path="/screen/alldisplay" element={<ManagerFloorDisplay />} />
            <Route path="/screen/advanced-display" element={<AdvancedScreen />} />
            <Route path="/screen/agent-display" element={<AgentDisplay />} />
            <Route path="/screen/agent" element={<Agent />} />
            <Route path="/screen/fighter" element={<SalesFightArena />} />
            <Route path="/screen/wide-display" element={<WideScreen />} />
            <Route path="/screen/wide-display2" element={<WideScreenAnimated />} />
            <Route path="/screen/manager-orders" element={<ManagerOrderWidescreen />} />
            <Route path="/screen/nexus" element={<Nexus />} />
            <Route path="/screen/central-report" element={<CentralReport />} />
            <Route path="/screen/test-display" element={<TestScreen />} />


            <Route path="/screen/live-battle" element={<LiveBattleDisplay />} />
            <Route path="/screen/sales-reports" element={<SalesReports />} />

            <Route path="/join-employee" element={<JoinEmployee />} />






            <Route path="/sales/leads" element={<ProtectedRoute resource="sales" actions={["read", "write", "update"]}><Leads /></ProtectedRoute>} />
            <Route path="/sales/leads/:leadObjId" element={<ProtectedRoute resource="sales" actions={["read", "write", "update"]}><LeadDetails /></ProtectedRoute>} />





            <Route path="/payroll/conducts" element={<ProtectedRoute resource="payroll" actions={["read", "write", "update"]}><Conducts /></ProtectedRoute>} />

        </Routes>
    )
}

export default RoutesPage